import { settings } from 'settings';
import Fetch from 'utils/fetch';
import { CourierObj } from './fetchInbound';

export async function fetchCourierArray(): Promise<CourierObj[]> {
  try {
    const response: Response = await Fetch.get({
      url: `${settings.newApiUrl}/inbound/courierArray`,
    });

    if (response.ok) {
      const courierArray: {
        courierArray: CourierObj[];
      } = await response.json();
      console.log('courierArray', courierArray);

      return courierArray.courierArray;
    }
  } catch (error) {
    return [];
  }
}
